export const redirect = location => {
	window.location.href = location;
};
